module.exports = __webpack_public_path__ + "static/media/8.ff827571.JPG";